import { Text } from '@chakra-ui/react';
import { BaseTooltip, BaseTag } from '@cks-internal/react-base';

type Props = {
  flsq: number | undefined;
};

/**
 * FooterFlsqBadge component displays the FLSQ number as a badge with hover tooltip.
 *
 * The tooltip explains that if the FLSQ doesn't match the edit activity screen,
 * the user should refresh the page to resolve sync issues.
 *
 * @component
 * @param {Props} props - Component props
 * @param {number | undefined} props.flsq - The FLSQ number to display
 * @returns {JSX.Element|null} FLSQ badge with tooltip, or null if no FLSQ
 */
export const FooterFlsqBadge = (props: Props) => {
  // Don't render if no FLSQ
  if (!props.flsq) {
    return null;
  }

  return (
    <BaseTooltip
      content={
        <Text fontSize='sm' maxW='200px' textAlign='center'>
          <Text fontWeight='bold' mb={1}>
            FLSQ: {props.flsq}
          </Text>
          <Text>
            If this number doesn't match the edit activity screen, please refresh the page to resolve sync issues.
          </Text>
        </Text>
      }>
      <BaseTag
        bg='white'
        color='black'
        variant='solid'
        fontSize='sm'
        fontWeight='bold'
        px={3}
        py={2}
        cursor='help'
        border='1px solid'
        borderColor='gray.300'>
        FLSQ: {props.flsq}
      </BaseTag>
    </BaseTooltip>
  );
};
